import React from 'react'
import {Route, Navigate} from 'react-router-dom'

const AuthRoute = () => {
    return (
        <Navigate to='/'/>
    )
}

export default AuthRoute